<template>
  <div class="h-full">
    <el-row type="flex" justify="center" align="middle" class="h-full">
      <el-card class="login-card">
          <el-row type="flex" justify="center" align="middle" class="h-full">
          <img :src="require('assets/logo.png')"  class="logo" />
        </el-row>
        <div class="clearfix grid-title no-border borderTop">
          <h4>Error al querer iniciar session</h4>
        </div>
      </el-card>
    </el-row>
  </div>
</template>

<script>
export default {
  async created(){
    
  },
  data() {
    return {};
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.logo {
  margin-bottom: 20px;
  filter: invert(59%) sepia(46%) saturate(2031%) hue-rotate(143deg)
    brightness(93%) contrast(92%);
}
.login-card {
  background-color: #f0f0f0;
}
.login-card {
  width: 450px;
}
</style>